export enum NotificationToastBodyBlock {
  Root = 'NotificationToastBody',
}
